import { Routes } from '@angular/router';
import { authRoutes } from '@pages/auth/auth.routes';
import { inicioRoutes } from '@pages/inicio/inicio.routes';
import { LoginGuard } from '@core/guard/login-guard.guard';
import { AuthGuard } from '@core/guard/auth-guard.guard';
import { modulosLayoutRoutes } from '@pages/modules/modules-layout.routes';
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('@pages/auth/auth.component').then((m) => m.AuthComponent),
    children: [...authRoutes],
    canActivate: [AuthGuard],
  },
  {
    path: 'dashboard',
    loadComponent: () => import('@pages/inicio/inicio.component'),
    children: [...inicioRoutes],
    canActivate: [LoginGuard],
  },
  {
    path: 'modulos',
    loadComponent: () => import('@pages/modules/modules-layout.component'),
    children: [...modulosLayoutRoutes],
    canActivate: [LoginGuard],
  },
  { path: '**', redirectTo: '/login' },
];
